import { environment } from '../../environments/environment';

export type MeterHelpTypeId = 'modern' | 'clock' | 'digital';

export function coerceBrandingString(value: unknown): string | null {
  if (value == null) {
    return null;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return null;
}

export function resolveBundledAsset(stem: string, ext: string, isGgm: boolean): string {
  const folder = isGgm ? 'ggm' : 'generic';
  return `assets/${folder}/${stem}.${ext}`;
}

export function resolveBundledAssetFromPath(assetPath: string, isGgm: boolean): string {
  const stripped = assetPath
    .replace(/^assets\/(img|ggm|generic)\//, '')
    .replace(/^(ggm|generic)_/, '');
  const dot = stripped.lastIndexOf('.');
  if (dot <= 0) {
    return resolveBundledAsset(stripped, 'png', isGgm);
  }
  const stem = stripped.slice(0, dot);
  const ext = stripped.slice(dot + 1);
  return resolveBundledAsset(stem, ext, isGgm);
}

export function normalizeAssetUrl(
  raw: string | null | undefined,
  apiBaseUrl: string = environment.apiUrl,
): string | null {
  const trimmed = coerceBrandingString(raw);
  if (!trimmed) {
    return null;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`;
  }
  if (trimmed.startsWith('/')) {
    const base = apiBaseUrl.replace(/\/$/, '');
    return `${base}${trimmed}`;
  }
  return trimmed;
}

export function resolveAssetUrl(
  apiUrl: string | null | undefined,
  stem: string,
  ext: string,
  isGgm: boolean,
  apiBaseUrl: string = environment.apiUrl,
): string {
  const normalized = normalizeAssetUrl(coerceBrandingString(apiUrl) ?? undefined, apiBaseUrl);
  if (normalized) {
    return normalized;
  }
  return resolveBundledAsset(stem, ext, isGgm);
}
